function start(selector?: string, config: Record<string, any> = {}): void {
    format(selector, config);
    lineNumbering(selector, config);
}

function format(selector?: string, config: Record<string, any> = {}): void {
    //
    const root = (config.element ?? config.node ?? document) as ParentNode;
    const elements = root.querySelectorAll<HTMLElement>(selector ?? 'pre');

    //
    for (const element of elements) {
        const txt = element.textContent
            .replace(/^[\r\n]+/, '') // strip leading newline
            .replace(/\s+$/g, ''); // strip trailing whitespace

        if (/^\S/gm.test(txt)) {
            element.textContent = txt;
            continue;
        }

        let mat;
        let str = '';
        const re = /^[\t ]+/gm;
        let len;
        let min = 1e3;

        while ((mat = re.exec(txt))) {
            len = mat[0].length;

            if (len < min) {
                min = len;
                str = mat[0];
            }
        }

        if (min === 1e3) {
            element.textContent = txt;
            continue;
        }

        element.textContent = txt.replace(new RegExp('^' + str, 'gm'), '');
    }
}

function lineNumbering(selector?: string, config: Record<string, any> = {}): void {
    const root = (config.element ?? config.node ?? document) as ParentNode;
    const elements = root.querySelectorAll<HTMLElement>(selector ?? 'pre');

    for (const element of elements) {
        const lines = (element.textContent ?? '').split('\n');
        element.textContent = '';

        for (let i = 0; i < lines.length; i++) {
            const elSpan = document.createElement('span');
            elSpan.className = 'line';
            elSpan.textContent = lines[i];
            element.appendChild(elSpan);

            if (i < lines.length - 1) {
                element.appendChild(document.createTextNode('\n'));
            }
        }
    }
}

function clipboard(element: HTMLElement, selector?: string): string {
    const elements = element.querySelectorAll<HTMLElement>(selector ?? 'pre');

    const lines: string[] = [];

    for (const element of elements) {
        const listSpan = element.querySelectorAll<HTMLElement>('span');

        if (listSpan.length) {
            for (const elSpan of listSpan) {
                lines.push(elSpan.textContent ?? '');
            }
        } else {
            const elCode = element.querySelector('code');

            if (elCode) {
                lines.push(elCode.textContent ?? '');
            } else {
                lines.push(element.textContent ?? '');
            }
        }
    }

    return lines.join('\n');
}

// ----------------------------------------------------------------------------

export { start, format, lineNumbering, clipboard };
